import { render, staticRenderFns } from "./CleanerEvents.vue?vue&type=template&id=6b831517"
import script from "./CleanerEvents.vue?vue&type=script&lang=js"
export * from "./CleanerEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports